import type { IdentifyOptionIdType } from '../../types';

export const IDENTIFY_OPTIONS: {
  id: IdentifyOptionIdType;
  title: string;
}[] = [
  { id: 'male', title: '👨 Male' },
  { id: 'female', title: '👩 Female' },
  { id: 'other', title: '👁️ Other' },
  { id: 'prefer_not_to_say', title: '❌ Prefer not to say' },
];
